import { render, staticRenderFns } from "./CSelectBox.vue?vue&type=template&id=a5225c12&scoped=true"
import script from "./CSelectBox.vue?vue&type=script&lang=js"
export * from "./CSelectBox.vue?vue&type=script&lang=js"
import style0 from "./CSelectBox.vue?vue&type=style&index=0&id=a5225c12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5225c12",
  null
  
)

export default component.exports